import { Record, List } from 'immutable';
export class ChildCheckout extends Record({
    autoCheckedOut: false,
    checkinLoginId: '',
    checkinTime: '',
    checkoutLoginId: '',
    checkoutTime: '',
    childCheckinId: '',
    childId: '',
    deletedAt: '',
    goHomeWithChildId: '',
    groupId: '',
    hours: undefined,
    institutionId: '',
    pickupRelationId: '',
    pickupTime: '',
}) {
}
export const transformGroups = (groups) => {
    return groups.map(group => new GoHomeWithChildrenGroup({
        ...group,
        children: List(group.children.map(child => {
            const name = child.name.split(' ');
            return {
                ...child,
                id: child.childId,
                image: {
                    small: child.image,
                },
                name: {
                    firstName: name[0],
                    lastName: name[1],
                    fullName: child.name,
                },
            };
        })),
    }));
};
export class GoHomeWithChildrenGroup extends Record({
    children: List(),
    color: '',
    groupId: '',
    image: '',
    title: '',
}) {
}
